function formatRelativeTime(date, now) {
  const diffMs = now.getTime() - date.getTime();
  const diffSeconds = diffMs / 1000;

  if (diffSeconds < 0) {
    return 'just now';
  }

  const diffMinutes = diffSeconds / 60;
  const diffHours = diffMinutes / 60;
  const diffDays = diffHours / 24;

  if (diffDays >= 7) {
    const sameYear = date.getUTCFullYear() === now.getUTCFullYear();
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthDay = months[date.getUTCMonth()] + ' ' + date.getUTCDate();

    return sameYear ? monthDay : monthDay + ', ' + date.getUTCFullYear();
  }

  if (diffMinutes < 1) {
    return 'just now';
  }

  if (diffMinutes < 60) {
    return Math.floor(diffMinutes) + 'm ago';
  }

  if (diffHours < 24) {
    return Math.floor(diffHours) + 'h ago';
  }

  return Math.floor(diffDays) + 'd ago';
}

function initRelativeTimestamps(elements) {
  const now = new Date();

  elements.forEach(function (el) {
    const timestamp = el.getAttribute('datetime');
    if (!timestamp) {
      return;
    }

    el.textContent = formatRelativeTime(new Date(timestamp), now);
  });
}
